import React, { Component } from 'react'
import SerializeForm from 'form-serialize'
import PropTypes from 'prop-types'
import ReactRouterPropTypes from 'react-router-prop-types'

import { Grid, GridCell } from 'rmwc/Grid';
import { Card } from 'rmwc/Card';
import { Typography } from 'rmwc/Typography';
import { FormField } from 'rmwc/FormField';
import { TextField } from 'rmwc/TextField';
import {Button} from 'rmwc/Button';
import ReactGA from 'react-ga';

import { connect } from 'react-redux'
import * as api from '../api/api'
import * as actions from '../actions'

// React Material Web Components

import StatusMessage from '../util/StatusMessage'


class TPOHallticket extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorMsg: '',
      status: '',
      downloadButtonState: false,
      loading:false,
      selectedTrack: 0,
      data:{
        'test_city': '',
        'hallticketDetails': []
      }
    }
    
  }

  componentDidMount() {
    ReactGA.set({ userId: this.props.user.id });
    ReactGA.initialize('UA-139837993-1');
    ReactGA.pageview('/tpo_user_hallticket');

    let data = Object.assign({}, this.state.data)

    return api.userHallticketDetails(this.props.user.accessToken)
      .then((result) => {
        if(result.status === 'success'){
          data.test_city = result.test_city
          data.hallticketDetails = result.data
          this.setState({status:'success', data:data})
        }
        
    })
  }

  handleHallticketDownload = (e, hallticketrow) =>{

    e.preventDefault()
    let hallTicketId = hallticketrow.id
    hallTicketId = hallTicketId + ".pdf"

    //disable download button until download
    this.setState({downloadButtonState:true, loading:true, selectedTrack:hallticketrow.id})

    api.downloadHallticket(this.props.user.accessToken, hallTicketId)
      .then((result) => {
        if (result instanceof Blob){
          this.setState({loading:false, downloadButtonState:false, errorMsg: '' })
          
          const url = window.URL.createObjectURL(result);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'hallticket.pdf');
          document.body.appendChild(link);
          link.click();
        }
        else{
          this.setState({ loading:false, downloadButtonState:false, errorMsg: 'Unable to download reports. Please contact Administrator' })
          
        }  
    })

  }

  render() {
   
   let conentToShow
   let trackDetails
   let handleHallticketDownload = this.handleHallticketDownload
   let downloadButtonState = this.state.downloadButtonState
   let selectedTrack = this.state.selectedTrack

   let loaderComponent
    if(this.state.loading){
      loaderComponent = (
            <div className="loader-component">
              <div className="loader"></div>
              <h4> Hall Ticket is being generated. Please wait</h4>
            </div>
          )
    }


  
   let buttonDownloadComp
   if(this.state.status === 'success'){
     
    trackDetails =(<div>
      {this.state.data.hallticketDetails.map(function(hallticketrow) {

        
        if(downloadButtonState && selectedTrack == hallticketrow.id){
          buttonDownloadComp = <Button dense disabled={downloadButtonState} onClick={((e) => handleHallticketDownload(e, hallticketrow))}>Please wait</Button>
        }
        else{
         buttonDownloadComp = <Button dense disabled={downloadButtonState} onClick={((e) => handleHallticketDownload(e, hallticketrow))}>Download</Button>
        }

        return (
          <Grid>
          <GridCell span="2">
            <Typography use="subtitle2">Test Track</Typography>
          </GridCell>
          <GridCell span="6">
            <Typography use="subtitle2">{hallticketrow.test_track}</Typography>
            
          </GridCell>
          <GridCell span="4">
            {buttonDownloadComp}
          </GridCell>
          </Grid>
        )
      })}
      </div>
     )

     conentToShow= 
      (<div><Grid className="opportunity-list-item">
        <GridCell span="12">
          <Typography use="subtitle1">Please go through the details below and click on download link to download the hallticket</Typography>
          <br/>
          <Typography use="subtitle1">In case of any queries/concerns, please drop us an email at team@centa.org. You can also WhatsApp us on +91 7349662401</Typography>
        </GridCell>
        
        <GridCell span="12">
          <Typography use="subtitle1"><u>Registration Details</u></Typography>
        </GridCell>
        
        <GridCell span="2">
          <FormField className="opportunity-form-field">
            <Typography use="subtitle2">Test City</Typography>
          </FormField>
        </GridCell>
        <GridCell span="10">
           <FormField className="opportunity-form-field">
            <Typography use="subtitle2">{this.state.data.test_city}</Typography>
           </FormField>   
        </GridCell>
        
      </Grid>{trackDetails}</div>
      )

      
    }
    else {
      conentToShow = (<Grid className="opportunity-list-item">
        <GridCell span="12">
          <Typography use="subtitle1">In case you have completed your registration for CENTA TPO 2019, you will be able to download the hall ticket shortly</Typography>
          <br/>
          <Typography use="subtitle1">In case of any queries/concerns, please drop us an email at team@centa.org. You can also WhatsApp us on +91 7349662401</Typography>
        </GridCell>
        </Grid>
      )
    }

    

    return (
      <div> 
       <Grid>
        <GridCell span="12">
          {loaderComponent}
          <form onSubmit={this.handleSubmit} style={{width: '100%'}}>
            <Card style={{padding: '25px'}}>
                <Typography use="headline5">TPO - Hall Ticket Download</Typography>
                
                <GridCell span="12" className="button-section">
                </GridCell>
                {conentToShow}
            </Card>
          </form>  
        </GridCell>
       </Grid>
      </div> 
    )
  }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(TPOHallticket)




// WEBPACK FOOTER //
// ./src/views/TPOHallticket.jsx